var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightBackArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{clip-path:url(#a);}.c{fill:#0c3058;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 40,
    height: 40,
    transform: "translate(327 116)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-327 -116)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(327 114.75)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M11.25,22.5H26.081L21.54,27.95a1.25,1.25,0,0,0,1.921,1.6l6.25-7.5a1.17,1.17,0,0,0,.109-.193,1.184,1.184,0,0,0,.089-.155,1.232,1.232,0,0,0,.09-.448s0,0,0-.005,0,0,0,0a1.232,1.232,0,0,0-.09-.448,1.184,1.184,0,0,0-.089-.155,1.17,1.17,0,0,0-.109-.192l-6.25-7.5a1.25,1.25,0,0,0-1.921,1.6L26.081,20H11.25a1.25,1.25,0,0,0,0,2.5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightBackArrow);
export default __webpack_public_path__ + "static/media/right-back-arrow.b248935d33f4a6232af46f0253e1e88f.svg";
export { ForwardRef as ReactComponent };